import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type OverrideStaff = {
    override: string | null;
    overrideType: 'staff' | 'student' | 'parent' | null;
    overrideLabel: string | null;
    setOverride: (override: string | null) => void;
    setStudentOverride: (studentNumber: string, label: string) => void;
    setParentOverride: (email: string, label: string) => void;
};

export const useStaffOverrideStore = create<OverrideStaff>()(
    persist(
        (set, get) => ({
            override: '',
            overrideType: null,
            overrideLabel: null,
            setOverride: (override) => set({ override, overrideType: override ? 'staff' : null, overrideLabel: null }),
            setStudentOverride: (studentNumber, label) => set({ override: `student:${studentNumber}`, overrideType: 'student', overrideLabel: label }),
            setParentOverride: (email, label) => set({ override: `parent:${email.toLowerCase()}`, overrideType: 'parent', overrideLabel: label }),
        }),
        { name: 'staff-override' }
    )
);

const actualStaffIdentityPaths = ['/roles/my-actual-roles', '/directory/staff/communication-recipients']

export function getUsernameOverrideForRequest(url?: string) {
    const state = useStaffOverrideStore.getState()
    const override = state.override?.trim()
    if (!override) return null
    if (state.overrideType === 'staff') return override
    const path = url?.toLowerCase() ?? ''
    return actualStaffIdentityPaths.some(identityPath => path.includes(identityPath)) ? null : override
}
